import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CustomerDetailer from '../../../../views/InvisibleTouchManager/CustomerDetailer/CustomerDetailer';
import InvisibleTouchManager from '../../../../views/InvisibleTouchManager/InvisibleTouchManager';

const InvisibleTouchManagerPageRoute = () => {
	return (		
		<Routes>
			<Route
				path="/customerDetailer"
				element={<CustomerDetailer />}
			/>
			<Route
				path=""
				element={<InvisibleTouchManager />}
			/>				
		</Routes>		
	);
};

export default InvisibleTouchManagerPageRoute;
